<template>
	<div class="inner-page my-account">
		<AppHead title="My Account" />

		<PageHeader 
      title="My Account"
      desc="Manage your personal details and security"
      :hasButton="false"
      :showHelper="true"
      helpTitle="Welcome to My Account"
      helpDesc="Within this page you can update your name and email, update your password and turn on Two Factor Authentication which will greatly enhance the security of your account and consequently your documents. You can also log out of other logged in sessions from other computers."
			:hr="true"
      />


		<div>
			<div class="">
				<div v-if="$page.props.jetstream.canUpdateProfileInformation">
					<update-profile-information-form :user="$page.props.user" />

					<jet-section-border />
				</div>

				<div v-if="$page.props.jetstream.canUpdatePassword">
					<update-password-form class="mt-10 sm:mt-0" />

					<jet-section-border />
				</div>

				<div v-if="$page.props.jetstream.canManageTwoFactorAuthentication">
					<two-factor-authentication-form class="mt-10 sm:mt-0" />

					<jet-section-border />
				</div>

				<logout-other-browser-sessions-form :sessions="sessions" class="mt-10 sm:mt-0" />

				<template v-if="$page.props.jetstream.hasAccountDeletionFeatures">
					<jet-section-border />

					<delete-user-form class="mt-10 sm:mt-0" />
				</template>
			</div>
		</div>
	</div>
</template>

<script>
	import AppLayout from '@/Layouts/AppLayout.vue'
	import DeleteUserForm from '@/Pages/Profile/Partials/DeleteUserForm.vue'
	import JetSectionBorder from '@/Jetstream/SectionBorder.vue'
	import LogoutOtherBrowserSessionsForm from '@/Pages/Profile/Partials/LogoutOtherBrowserSessionsForm.vue'
	import TwoFactorAuthenticationForm from '@/Pages/Profile/Partials/TwoFactorAuthenticationForm.vue'
	import UpdatePasswordForm from '@/Pages/Profile/Partials/UpdatePasswordForm.vue'
	import UpdateProfileInformationForm from '@/Pages/Profile/Partials/UpdateProfileInformationForm.vue'

	import AppHead from "@/Components/AppHead"
	import PageHeader from "@/Components/PageHeader"

	export default {
		props: ['sessions'],
		layout: AppLayout,
		components: {
			DeleteUserForm,
			JetSectionBorder,
			LogoutOtherBrowserSessionsForm,
			TwoFactorAuthenticationForm,
			UpdatePasswordForm,
			UpdateProfileInformationForm,
			AppHead,
			PageHeader
		},
	}
</script>

<style lang="sass">

.my-account
  font-family: 'Roboto'
  color: #252525

  .font-medium
    font-family: 'Roboto Condensed'
    font-weight: 700

</style>